
import { PropType, defineComponent } from 'vue';
import ConfirmationOverlay from '@/components/ConfirmationOverlay.vue';
import { titleCase } from '@/shared/helpers';

export default defineComponent({
    name: 'CrossCompanyConfirmation',
    components: {
        ConfirmationOverlay,
    },
    props: {
        driverCompany: {
            type: String as PropType<string | undefined>,
            required: true,
        },
        trailerNumber: {
            type: String as PropType<string | undefined>,
            required: true,
        },
        trailerCompany: {
            type: String as PropType<string | undefined>,
            required: true,
        },
    },
    computed: {
        companyMismatchTitle(): string {
            let title = '';
            if (this.trailerCompany && this.driverCompany) {
                const trailerCompany = titleCase(this.trailerCompany);
                const driverCompany = titleCase(this.driverCompany);
                title = `This is a ${trailerCompany} trailer. You can only attach to ${driverCompany} trailers.`;
            }
            return title;
        },
    },
});
